import Image from "next/image";
// CMS-supplied hrefs are emitted verbatim - do NOT swap this for @repo/ui/navigation.
// The CMS localizes its own URLs (e.g. "cl/es/centro-de-ayuda/") and also returns
// external/relative ones, so prefixing here would double or corrupt the locale.
import Link from "next/link";

import type { PageFooterHeader } from "../../types/cms/common";

type SocialMediaLinksProps = {
  footerHeaderData: PageFooterHeader;
};

export default function SocialMediaLinks({ footerHeaderData }: SocialMediaLinksProps) {
  const paymentLabel =
    footerHeaderData?.footer?.paymentMethods?.paymentMeansLabel ?? "Payment methods:";

  const socialLabel = footerHeaderData?.footer?.paymentMethods?.socialMediaLabel ?? "Follow us on:";
  return (
    <div className="responsive-layout responsive-padding text-brand-blue py-2">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-center">
        {/* Payment Means */}
        <div className="flex flex-col">
          <p className="mb-2 font-semibold max-md:text-center">{paymentLabel}</p>
          <div
            className="flex flex-wrap items-center gap-2 max-md:justify-center"
            data-testid="payment-methods"
          >
            {footerHeaderData.footer.paymentMethods.items.map((item) =>
              item.link ? (
                <Link key={item.codename} href={item.link} className="inline-flex items-center">
                  <Image
                    src={item.imageUrl}
                    alt={item.imageAlt || item.text}
                    width={item.imageWidth}
                    height={item.imageHeight}
                  />
                </Link>
              ) : (
                <Image
                  key={item.codename}
                  src={item.imageUrl}
                  alt={item.imageAlt || item.text}
                  width={item.imageWidth}
                  height={item.imageHeight}
                />
              ),
            )}
          </div>
        </div>

        {/* Social Links */}
        <div className="flex flex-col" data-testid="social-media-links">
          <p className="mb-2 font-semibold max-md:text-center">{socialLabel}</p>
          <div className="flex flex-wrap items-center gap-4 max-md:justify-center">
            {/* {socialIcons.map(({ src, alt, href }) => ( */}
            {footerHeaderData.footer.socialMediaLinks.items.map((item) => (
              <Link
                key={item.codename}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="relative h-8 w-8"
              >
                <Image
                  src={item.imageUrl}
                  alt={item.imageAlt || item.text}
                  fill
                  className="object-contain transition hover:opacity-80"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
